export class PayQuantityType {
  static get Determined () {
    return 1
  }
  static get Undetermined () {
    return 2
  }

  static PayQuantityTypeName (payQuantityType) {
    let tmpType = parseInt(payQuantityType)
    let type = isNaN(tmpType) ? -1 : tmpType
    let name = ''
    switch (type) {
      case 1:
        name = '定量'
        break
      case 2:
        name = '不定量'
        break
    }
    return name
  }
}
